@if (availableWestnetzKontaktdaten$ | async; as contacts) {
  <div class="contact-container" fxLayout="row wrap">
    @for (contact of contacts; track contact.id; let i = $index) {
      <div fxFlex="25" class="card-container">
        <h3>Kontaktdaten Nr.{{ i + 1 }}</h3>
        <mat-card fxLayoutGap="1rem" fxLayout="column">
          <redispatch-labeled-textbox label='Name' [text]="contact.name"></redispatch-labeled-textbox>
          <redispatch-labeled-textbox label='Adresse' [text]="contact.adresse"></redispatch-labeled-textbox>
          @for (kontaktItem of contact.kontakte; track kontaktItem) {
            <redispatch-labeled-textbox [label]="kontaktItem.type"
              [text]="kontaktItem.data">
            </redispatch-labeled-textbox>
          }
        </mat-card>
      </div>
    }
  </div>
}
